export default ({ $config, store }, inject) => {
    const globalSettings = store.getters['global/globalSettings'];
    const isRomania = globalSettings?.is_romanian || false;
    const phoneCode = isRomania ? '+40' : '+(373)';
    const phoneLength = isRomania ? 15 : 17;
    const isAuthentificationUsed = globalSettings?.additional_settings?.is_user_cabinet || false;

    inject('pocketSettings', {
        isRomania: isRomania,
        phoneCode: phoneCode,
        phoneLength: phoneLength,

        isAuthentificationUsed: isAuthentificationUsed
    });
};
